export default __webpack_public_path__ + "static/media/Breeches of the Dark Messenger.80c3ff6a.jpg";